<template>
  <div class="col-sm-12 col-md">
    <InputWidget
      v-model="model"
      :error="errors"
      id="input-bank_account_address_1"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
    />
  </div>
</template>

<script>
import InputWidget from "../../../core/InputWidget";
import BaseInputMixin from "@/mixins/signupInputMixin";

export default {
  name: "BankAccountAddress1",
  components: {InputWidget},
  mixins: [BaseInputMixin('bank_account.address')],

  data() {
    return {
      name: 'address',
      defaultLabel: this.$t("Address 1")
    }
  }
}
</script>

<style scoped>

</style>
